module.exports = {"name":"maxLevel"}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/signals/inputs/max-level.json
// module id = /qc4
// module chunks = 0